import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { validate, mergeStyles } from 'wix-rich-content-common';
import pluginDividerSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-divider.schema.json';
import { isEqual } from 'lodash';
import { A as ALIGNMENTS, S as SIZES, a as SIZE_LARGE, D as DEFAULTS, s as sizeClassName } from './viewer-loadable2.js';
import { s as styles, D as DividerLine } from './divider-line.js';
import '@loadable/component';
import 'ricos-types';

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var getNextValue = function getNextValue(array, currentValue) {
  return array[(array.indexOf(currentValue) + 1) % array.length];
};
var Divider = function Divider(_temp) {
  var _this = this;
  var _ref = _temp === void 0 ? {} : _temp,
    type = _ref.type,
    config = _ref.config;
  this.getNextAlignmentConfig = function () {
    var _a;
    var alignment = getNextValue(ALIGNMENTS, (_a = _this.config) == null ? void 0 : _a.alignment);
    return __spreadProps(__spreadValues({}, _this.config), {
      alignment: alignment
    });
  };
  this.getNextSizeConfig = function () {
    var _a;
    var size = getNextValue(SIZES, (_a = _this.config) == null ? void 0 : _a.size);
    return __spreadProps(__spreadValues({}, _this.config), {
      size: size
    });
  };
  this.isAlignmentDisabled = function () {
    return _this.size === SIZE_LARGE;
  };
  this.type = type || DEFAULTS.type;
  this.config = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  this.size = this.config.size;
  this.alignment = this.config.alignment;
};

var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var DividerComponent = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(DividerComponent, _PureComponent);
  function DividerComponent(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    validate(props.componentData, pluginDividerSchema);
    return _this;
  }
  var _proto = DividerComponent.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginDividerSchema);
    }
  };
  _proto.render = function render() {
    this.styles = this.styles || mergeStyles({
      styles: styles,
      theme: this.props.theme
    });
    var divider = new Divider(this.props.componentData);
    var type = divider.type,
      size = divider.size,
      alignment = divider.alignment;
    var className = classNames(this.styles["divider-container"], this.styles["divider-container--" + type], this.props.isMobile && this.styles["divider-container--mobile"], this.props.className);
    return /* @__PURE__ */React.createElement("div", {
      className: className,
      "data-hook": "divider-" + type
    }, /* @__PURE__ */React.createElement(DividerLine, {
      type: type,
      width: "100%",
      size: size,
      alignment: alignment,
      styles: this.styles,
      isMobile: this.props.isMobile
    }));
  };
  return DividerComponent;
}(PureComponent);
__publicField(DividerComponent, "sizeClassName", function (componentData, theme) {
  return sizeClassName();
});
DividerComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  className: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export { DividerComponent as default };

import 'wix-rich-content-plugin-divider/dist/loadable/viewer/es/styles.viewer.min.global.css'